import { render, staticRenderFns } from "./EventComments.vue?vue&type=template&id=a9497d26&scoped=true"
import script from "./EventComments.vue?vue&type=script&lang=js"
export * from "./EventComments.vue?vue&type=script&lang=js"
import style0 from "./EventComments.vue?vue&type=style&index=0&id=a9497d26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9497d26",
  null
  
)

export default component.exports